import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import TableGrouping, { IColumnsGrouping } from '../../components/table-grouping/TableGrouping';
import AppContext from '../../../AppContext';
import { IAttribution } from '../models/timesheetModels';
import { getListWorkDay } from '../../category/services/symbolServices';
import { RESPONSE_STATUS_CODE, TYPE_REF, VARIABLE_STRING } from '../../constants/moduleConsts';
import useMultiLanguage from '../../../hook/useMultiLanguage';
import { toast } from "react-toastify";
import Autocomplete from '../../components/input/autocomplete';
import { CODE_WEEKEND, NUMBER_SHEET_TIMESHEET_OVERVIEW } from '../constants/timesheetConsts';
import { variantStandardStyle } from '../../components/input/autocomplete/styleJS';
import { checkWeekend, checkWeekendOrHoliday } from '../../utils/functionUtils';

function TableTimesheets(props: any) {
    const { refsArray, setRefsArray, data, dataKHChamCong, isView = true, dateSearch, listAttribution = [] } = props;
    const { setPageLoading } = useContext(AppContext);
    const { lang } = useMultiLanguage();

    const loadNgayLe = (listAttribution: any) => {
        const dayOfMonth = new Date(dateSearch.nam, dateSearch?.thang, 0).getDate();
        const yellowTds = document.querySelectorAll("td.isWeekend");
        const theadRows = document.querySelectorAll("thead tr th");
        const listAttributionShow = listAttribution.filter((attribution: any) => attribution.isShowed?.includes(NUMBER_SHEET_TIMESHEET_OVERVIEW))

        theadRows.forEach((th) => {
            th.classList.remove("isWeekend");
        });

        yellowTds.forEach((td) => {
            const colIndex = (td as HTMLTableCellElement).cellIndex;

            for (let i = theadRows.length - 1; i >= 0; i--) {
                const th1 = theadRows[colIndex + 2] as HTMLTableCellElement | null;
                const th2 = theadRows[colIndex + 2 + dayOfMonth + listAttributionShow.length] as HTMLTableCellElement | null;
                if (th1 && th2) {
                    th1.classList.add("isWeekend");
                    th2.classList.add("isWeekend");
                    break;
                }
            }
        });  
    };

    useEffect(() => {
        loadNgayLe(listAttribution)
    }, [])

    useEffect(() => {
        if (data.length > 0) {
            setTimeout(() => {
                loadNgayLe(listAttribution);
            }, 500);
        }
    }, [data, listAttribution]);

    const columns = ({ setRefsArray, dataKHChamCong, isView, dateSearch }: any): IColumnsGrouping[] => {
        const listColumn: IColumnsGrouping[] = [
            {
                name: "STT",
                field: "stt",
                render: (row: any, index: number, stt: number) => <span ref={setRefsArray && setRefsArray(index, VARIABLE_STRING.EMPLOYEE, TYPE_REF.AUTOCOMPLETE_REF, row?.id)}>{stt}</span>,
                isSticky: true,
            },
            {
                name: "Họ và tên",
                field: "employeeText",
                headerStyle: {
                    minWidth: "170px"
                },
                cellStyle: {
                    textAlign: "left"
                },
                isSticky: true,
            },
            {
                name: "Khoa phòng",
                field: "phongBanText",
                isSticky: true,
                headerStyle: {
                    minWidth: "200px"
                },
                cellStyle: {
                    textAlign: "left"
                },
            },
            {
                name: "Cấp bậc chức vụ",
                field: "chucDanhText",
                headerStyle: {
                    minWidth: "200px"
                },
                cellStyle: {
                    textAlign: "left"
                },
            },
        ];

        const weekdays = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];
        const listDate = [];
        const dayOfMonth = new Date(dateSearch.nam, dateSearch?.thang, 0).getDate();

        for (let i = 1; i <= dayOfMonth; i++) {
            const currentDate = new Date(dateSearch.nam, dateSearch.thang - 1, i);
            const dayOfWeek = weekdays[currentDate.getDay()];
            listDate.push({
                name: String(i),
                field: `ngay${i}`,
                headerStyle: {
                    minWidth: "95px",
                },
                className: checkWeekend(dateSearch.nam, dateSearch.thang, i) ? `isWeekend` : '',
                cellClassName: (row: any, index: number) => {
                    return checkWeekendOrHoliday(row?.[`ngay${i}`]?.defaultCode) ? `isWeekend` : ''
                },
                child: [
                    {
                        name: dayOfWeek,
                        field: `thu${i}`,
                        headerStyle: {
                            minWidth: "95px",
                        },
                        className: checkWeekend(dateSearch.nam, dateSearch.thang, i) ? `isWeekend` : '',
                        cellClassName: (row: any, index: number) => {
                            return checkWeekendOrHoliday(row?.[`ngay${i}`]?.defaultCode) ? `isWeekend` : ''
                        },
                        render: (row: any, index: number) => {
                            return (
                                <>
                                    <span style={{ display: isView ? "block" : "none" }}>{row?.[`ngay${i}`]?.defaultCode === CODE_WEEKEND ? "" : row?.[`ngay${i}`]?.code}</span>
                                    <div style={{ display: isView ? "none" : "block" }}>
                                        <Autocomplete
                                            options={dataKHChamCong}
                                            placeholder='Nhập'
                                            name={`ngay${i}`}
                                            defaultValue={row?.[`ngay${i}`]?.code === CODE_WEEKEND ? "" : row?.[`ngay${i}`]}
                                            valueSearch="code"
                                            styles={variantStandardStyle("26px", checkWeekend(dateSearch.nam, dateSearch.thang, i))}
                                            isRefValue={true}
                                            getOptionLabel={(option) => option?.code}
                                            menuPortalTarget={document.body}
                                            ref={setRefsArray && setRefsArray(index, `ngay${i}`, TYPE_REF.AUTOCOMPLETE_REF, row?.id)}
                                        />
                                    </div>
                                </>
                            )
                        }
                    }
                ],
            });
        }

        listColumn.push({
            name: "Ngày trong tháng",
            field: "date",
            headerStyle: {
                minWidth: "180px"
            },
            child: listDate
        });

        const listStatistical: IColumnsGrouping[] = [];
        listAttribution.forEach((attribution: any) => {
            attribution.isShowed?.includes(NUMBER_SHEET_TIMESHEET_OVERVIEW) && listStatistical.push({
                name: attribution?.name,
                field: attribution?.fieldName,
                headerStyle: {
                    minWidth: "180px"
                },
            })
        });

        listColumn.push({
            name: "Quy ra công",
            field: "statistical",
            headerStyle: {
                minWidth: "180px"
            },
            child: listStatistical
        });
        
        return listColumn;
    }
    
    // const memoizedTable = useMemo(
    //     () => {
    //         // setTimeout(() => !isView && setPageLoading(false), 10)
    //         if (refsArray) {
    //             refsArray.current = [];
    //         }
    //         return (
    //             <TableGrouping
    //                 className="table-custom"
    //                 id="timeSheets"
    //                 columns={columns({
    //                     setRefsArray,
    //                     dataKHChamCong,
    //                     isView,
    //                     dateSearch
    //                 })}
    //                 data={data}
    //                 prefixDataField="data"
    //                 prefixTitleField="phongBanText"
    //             />
    //         )
    //     },
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    //     [setRefsArray, data, dataKHChamCong, isView]
    // );

    useEffect(() => {
        if (!isView) {
            const timeout = setTimeout(() => setPageLoading(false), 10);
            return () => clearTimeout(timeout);
        }
    }, [isView]);

    useEffect(() => {
        if (refsArray) {
            refsArray.current = [];
        }
    }, [data]);

    const memoizedColumns = useMemo(() => columns({
        setRefsArray,
        dataKHChamCong,
        isView,
        dateSearch
    }), [setRefsArray, dataKHChamCong, isView, dateSearch, listAttribution]);

    return (
        <div>
            <TableGrouping
                className="table-custom"
                id="timeSheets"
                columns={memoizedColumns}
                data={data}
                prefixDataField="data"
                prefixTitleField="phongBanText"
            />
        </div>
    )
}

export default TableTimesheets